export enum MapType {
    DtcDescriptions = 1,
    DtcClasses = 2,
    DtcMasks = 3,
    DtcDescriptionsManufacturer = 4,
}
